import { BOOTSTRAP_API_PREFIX } from '@aibees/shared/constants';
import { HttpMethod } from '@aibees/shared/definition';
import { ReadBootstrapResponse } from '@aibees/shared/definition/bootstrap';
import { useBaseQuery } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { useCallback } from 'react';

let globalDebounceTimeout: NodeJS.Timeout | null = null;

export function useBootstrapApiBase<T extends ReadBootstrapResponse>() {
  const workspaceId = useWorkspace()?.id;

  const api = useBaseQuery<void, T>([useBootstrapApiBase.name, workspaceId], {
    url: BOOTSTRAP_API_PREFIX.replace(':wid', String(workspaceId)),
    method: HttpMethod.get,
  });

  const debouncedRefetch = useCallback(() => {
    if (globalDebounceTimeout) {
      clearTimeout(globalDebounceTimeout);
    }
    globalDebounceTimeout = setTimeout(() => {
      api.refetch();
      globalDebounceTimeout = null;
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- api.refetch is stable from React Query
  }, [api.refetch]);

  return { ...api, debouncedRefetch };
}
